module.exports = __webpack_public_path__ + "static/media/breakApart.dd96c300.svg";